import {Component, HostBinding} from '@angular/core';
import {ValidatorsErrorEnum} from '../shared/models/form.model';
import {I18nKeyEnum} from '../shared/models/language.model';
import {Subscription} from 'rxjs';
import {FormControl, FormGroup} from '@angular/forms';
import {AccountService} from '../shared/services/account.service';
import {VoiceBotService} from '../shared/services/voice-bot.service';
import {IconEnum} from '../shared/models/assets.model';
import {Feedback, FeedbackFormData} from '../shared/models/feedback.model';

@Component({
    selector: 'app-get-in-contact',
    standalone: false,
    templateUrl: './get-in-contact.component.html',
    styleUrl: './get-in-contact.component.scss'
})
export class GetInContactComponent {
    protected readonly I18nKeyEnum = I18nKeyEnum;
    protected readonly validatorsErrorEnum = ValidatorsErrorEnum;
    protected readonly ICONS = IconEnum;
    @HostBinding('class.get-in-contact') default = true;
    @HostBinding('class.test-call-missing') waitingForTheTestCall = true;
    public stars = Array(5).fill(1).map((x, i) => x + i);
    public subscriptions = new Subscription();
    public contactForm = new FormGroup({
        rating: new FormControl(),
        additionalText: new FormControl(),
        salutation: new FormControl(),
        firstName: new FormControl(),
        lastName: new FormControl(),
        email: new FormControl(),
        company: new FormControl()
    });
    public contactRequested = false;
    private rated = false;
    
    constructor(private readonly accountService: AccountService,
                private readonly voiceBotService: VoiceBotService) {
        this.initSubscriptions();
    }
    
    onClick(rating: number) {
        this.contactForm.controls.rating.setValue(rating);
        if (!this.rated) {
            setTimeout(() => {
                document.getElementById('get-in-contact')?.scrollIntoView({behavior: 'smooth'});
            });
        }
    }
    
    getInContact() {
        this.contactForm.markAllAsTouched();
        if (this.contactForm.invalid) {
            console.log('Missing data');
            return;
        }
        this.accountService.sendFeedbackRequest$(new Feedback((this.contactForm.value) as FeedbackFormData)).subscribe(
            () => {
                this.contactRequested = true;
            }
        )
    }
    
    private initSubscriptions() {
        this.subscriptions.add(this.accountService.user$.subscribe(user => {
             this.contactForm.controls.email.setValue(user.userAccount.email);
        }));
        this.subscriptions.add(this.voiceBotService.testCallRunning$
            .subscribe((state) => {
                console.log('testCallRunning$', !state);
                this.waitingForTheTestCall = !state;
                if (state) {
                    setTimeout(() => {
                        document.getElementById('get-in-contact')?.scrollIntoView({behavior: 'smooth'});
                    });
                }
            }));
        
    }
}
